export const SET_TIMEOFF_HISTORY_LOADING = 'SET_TIMEOFF_HISTORY_LOADING';
export const SET_TIMEOFF_HISTORY = 'SET_TIMEOFF_HISTORY';